import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  connect() {
    const modal = new Modal('#open-on-load-modal', {});
    modal.show();
  }
}
